'use strict';

module.exports = {
    SIGN: '로그인',
    SIGN_JOIN: '로그인 혹은 무료로 가입하기!',
    EMAIL_EXISTS: '이 계정이 이미 존재합니다.',
    INVALID_EMAIL: '유효한 이메일 주소를 입력하십시오.',
    INVALID_FIRST_NAME: '유효한 이름을 입력해 주세요.',
    INVALID_LAST_NAME: '유효한 성을 입력해 주세요.',
    INVALID_PASSWORD: '6 - 20자 사이로 입력해 주세요 (A-Z, a-z, 0-9 로만)',
    INVALID_REPASSWORD: '비밀번호가 다릅니다',
    INVALID_VALID_CODE: '유효한 코드를 입력해 주세요',
    UNAVIALABLE_SERVICE: '서비스를 사용할 수 없습니다. 잠시 후 다시 시도하십시오.',
    EMPTY_VALID_CODE: '그림에 보이는 글자를 입력해 주세요',
    NOT_MEMBER: '회원이 아니십니까?',
    ALREADY_MEMBER: '이미 알리익스프레스/알리바바 회원이십니까?',
    EMAIL: '이메일 주소',
    CONTACT_NAME: '연락처명:',
    FIRST_NAME: '이름',
    LAST_NAME: '성',
    PASSWORD: '비밀번호',
    REPASSWORD: '비밀번호 확인:',
    EMPTY_CODE: '보여지는 코드를 입력해 주세요',
    REFRESH: '다시 생성하기',
    CREATE_MY_ACCOUNT: '내 계정 만들기',
    NAME: '이름',
    VERIFICATION: '검증번호',
    AGREE_MENT: '계정을 생성함과 동시에',
    AE_MEMBER_SHIP: 'AliExpress.com 무료 멤버십가입 동의',
    AND: '및',
    PRIVACY_POLICY: '개인정보 정책에동의하시게 됩니다',
    SLIDE_SUBMIT: '오른쪽으로 이동하여 확인',
    SLIDE_SUBMIT_TIPS: '성공',
    LOADING: '로딩 중…',
    SLIDE_SUBMIT_ERROR_TIPS: '오른쪽으로 이동하여 확인',
    SHOP_NOW: '바로 구매',
    SIGN_IN: '로그인',
    REGISTER_SMS: 'SMS로 등록',
    REGISTER_EMAIL: '이메일로 등록',
    PHONE_NUMBER: '전화 번호',
    VALID_NUMBER: '유효한 전화 번호를 입력하세요.',
    SEND_SMS_CODE: 'SMS 코드 보내기',
    SMS_POLICY: 'SMS를 통해 입력한 전화 번호로 확인 코드를 보내드립니다. 국가 코드와 전화 번호가 모두 올바른지 확인하세요.',
    SEND_TO: '다음 번호로 코드를 보냈습니다',
    VERIFICATION_RECEIVED: '받은 인증 코드를 입력하거나',
    EDIT_NUMBER: '번호를 편집합니다.',
    RESEND_CODE: '코드 다시 보내기',
    LAST_STEP: '마지막 단계',
    SET_SIGN_IN_PASSWORD: '계정 보안을 강화하기 위해 로그인 비밀번호를 설정하세요.',
    INVALID_PHONE_PASSWORD: '6-20자(문자와 숫자만)',
    NOT_CORRECT_CODE: '코드가 잘못되었습니다. 다시 시도하십시오.',
    SAVE_PASSWORD: '암호 저장',
    NO_RECEIVED_CODE: '여전히 코드를 받지 못한 경우',
    VIA_EMAIL: '이메일을 통해 등록하세요'
};